import cAppeared from './components/c-appeared';
import cCustomSelect from './components/c-custom-select';
import cOutline from './components/c-outline';
import cControl from './components/c-control';
import cDestination from './components/c-destination';
import cDatepicker from './components/c-datepicker';
import preloader from './components/c-preloader';
import header from './blocks/header';
import cartDrawer from './blocks/cart-drawer';
import productDetail from './blocks/product-detail';
import myAccountTooltip from './blocks/my-account';
import formValidation from './blocks/form';
import logoBox from './blocks/logo-box';
import cQuantity from './components/c-quantity';
import cVideoControl from './components/c-video-control';
import { bindGlobalInteractionTracking } from './utils/gtm-interactions';

cAppeared();
cCustomSelect();
cOutline();
cControl();
cDestination();
cDatepicker();
preloader();
header();
cartDrawer();
productDetail();
cQuantity();
cVideoControl();
bindGlobalInteractionTracking();
myAccountTooltip();
formValidation();
logoBox();
